import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQrCodeScannerUpperLeftCorner = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "white",
		strokeWidth: 2,
		d: "M1 25V5a4 4 0 0 1 4-4h20",
		opacity: .7
	})
});
export default SvgQrCodeScannerUpperLeftCorner;
